"use client";
import { useAtom } from "jotai";
import { WindowWidthAtom } from "./dim-hook";
import { useIsMobile } from "./useIsMobile";
import { useEffect } from "react";
import { mobileProductGrid } from "@/utils/functions/global-constants";
import { setProperty } from "@/utils/functions/color-system";

const getActiveWidth = (
  winWidth: number,
  filtersInPage: boolean,
  small = 768,
) => {
  const smallViewPort = winWidth < small;
  const filterBlockWidth = 306 + 36;
  let viewPortPadding = smallViewPort
    ? 16
    : filtersInPage
    ? filterBlockWidth / 2 + 24
    : winWidth > 1252
    ? 48
    : 24;
  if (winWidth > 1252 || (winWidth < 1252 && winWidth > small))
    viewPortPadding += 4;
  const activeWidth = winWidth - 2 * viewPortPadding;
  const gap = smallViewPort ? mobileProductGrid.gap : 24;
  return { activeWidth, gap };
};

export const useResponsiveAttribs = () => {
  const [winWidth1] = useAtom(WindowWidthAtom);
  const mobile = useIsMobile();
  const winWidth = mobile ? winWidth1 : winWidth1;

  useEffect(() => {
    const blogImgRatio = 362 / 832;
    let wp: number, wd: number;
    const activeWidth = getActiveWidth(winWidth, false, 992).activeWidth;
    if (mobile) {
      wp = activeWidth - 32;
      wd = activeWidth;
    } else {
      wp = activeWidth - 340 - 32 - 48;
      wd = activeWidth - 340 - 32;
    }
    setProperty("--blog-in-page-width", `${wp}px`);
    setProperty("--blog-in-page-height", `${wp * blogImgRatio}px`);
    setProperty("--blog-details-width", `${wd}px`);
    setProperty("--blog-details-height", `${wd * blogImgRatio}px`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [winWidth]);
};
